import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
    console.warn(
        '⚠️  Supabase credentials chybí. Vytvoř Supabase projekt a doplň VITE_SUPABASE_URL a VITE_SUPABASE_ANON_KEY do .env.local'
    );
}

export const supabase = createClient(url || 'https://placeholder.supabase.co', key || 'placeholder', {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
    }
});

export const hasSupabaseConfig = Boolean(url && key);
